import script from "./DashboardWidgetCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardWidgetCard.vue?vue&type=script&setup=true&lang=js"

import "./DashboardWidgetCard.vue?vue&type=style&index=0&id=a2920d9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2920d9c"]])

export default __exports__